import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {BETTING_CONTAINER} from "../../betting-container-consts";
import {BettingContainerDrawerMenuOpenAndCloseClickEvent} from "../../models/drawer-menu/betting-container.drawer-menu.open-and-close.click-event";

export class BettingContainerDrawerMenuOpenAndCloseClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = BETTING_CONTAINER.ACTION_TYPES.DRAWER_MENU.onOpenAndClose;

  static injectables = [AnalyticsService];

  async action(params) {
    const sendParams = {
      ...params,
      eventName: params.isOpen ? 'open' : 'close',
      screen: params.screen,
    }

    const event: BettingContainerDrawerMenuOpenAndCloseClickEvent = new BettingContainerDrawerMenuOpenAndCloseClickEvent(sendParams);

    return this.analyticsService.createEvent(event);
  }
}
